// src/components/home/StickyBetaBadge.jsx
import React from "react";
import { useNavigate } from "react-router-dom";
import "./StickyBetaBadge.css";

const StickyBetaBadge = () => {
  const navigate = useNavigate();

  return (
    <div
      className="bvh-sticky-beta-badge"
      onClick={() => navigate("/our-journey")}
      title="BodhAI V2 Beta is Live!"
    >
      <span className="bvh-sticky-new-tag">NEW</span>
      <span className="bvh-sticky-pulse-dot"></span>
      <span className="bvh-sticky-text">
        <span className="bvh-highlight">V2 Beta</span> LIVE
      </span>
    </div>
  );
};

export default React.memo(StickyBetaBadge);
